import { FunctionComponent } from 'react'

import PostTitle from './Title'

const Loading: FunctionComponent = () => <PostTitle>Loading…</PostTitle>

export default Loading
